import { LoadingError } from './LoadingError';

const name = 'LoadingError';
export { LoadingError, name };

export type { LoadingErrorProps } from './types';
